var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerticalReports(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 498,
    height: 444,
    viewBox: "0 0 498 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_122_129776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 4,
    width: 498,
    height: 428,
    rx: 5,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 28,
    width: 92,
    height: 24,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 76,
    width: 450,
    height: 40,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 76,
    width: 450,
    height: 40,
    rx: 20,
    fill: "#001B53",
    fillOpacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_122_129776)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 80,
    width: 142,
    height: 32,
    rx: 16,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75,
    y: 88,
    width: 64,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 225,
    y: 88,
    width: 64,
    height: 16,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    x: 375,
    y: 88,
    width: 64,
    height: 16,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 132,
    width: 72,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 132,
    width: 72,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410,
    y: 132,
    width: 72,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 155,
    width: 450,
    height: 1,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 172,
    width: 112,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 172,
    width: 112,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 172,
    width: 32,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 176,
    width: 8,
    height: 8,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 199,
    width: 450,
    height: 1,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 170,
    width: 24,
    height: 20,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 216,
    width: 112,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 216,
    width: 112,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 216,
    width: 32,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 220,
    width: 8,
    height: 8,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 243,
    width: 450,
    height: 1,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 214,
    width: 24,
    height: 20,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 260,
    width: 112,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 260,
    width: 112,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 260,
    width: 32,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 264,
    width: 8,
    height: 8,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 287,
    width: 450,
    height: 1,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 258,
    width: 24,
    height: 20,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 304,
    width: 112,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 304,
    width: 112,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 304,
    width: 32,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 308,
    width: 8,
    height: 8,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 331,
    width: 450,
    height: 1,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 302,
    width: 24,
    height: 20,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84,
    y: 348,
    width: 112,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248,
    y: 348,
    width: 112,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 450,
    y: 348,
    width: 32,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 352,
    width: 8,
    height: 8,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 375,
    width: 450,
    height: 1,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 346,
    width: 24,
    height: 20,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386,
    y: 392,
    width: 96,
    height: 16,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442,
    y: 28,
    width: 40,
    height: 24,
    rx: 3,
    fill: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.52 43.62H211.98V45H204.915V35.1H206.52V43.62ZM216.749 37.35C217.479 37.35 218.124 37.505 218.684 37.815C219.244 38.125 219.679 38.575 219.989 39.165C220.309 39.745 220.469 40.44 220.469 41.25C220.469 42.06 220.309 42.76 219.989 43.35C219.679 43.93 219.244 44.375 218.684 44.685C218.124 44.995 217.479 45.15 216.749 45.15C216.019 45.15 215.374 44.995 214.814 44.685C214.254 44.375 213.814 43.93 213.494 43.35C213.174 42.76 213.014 42.06 213.014 41.25C213.014 40.44 213.174 39.745 213.494 39.165C213.814 38.575 214.254 38.125 214.814 37.815C215.374 37.505 216.019 37.35 216.749 37.35ZM216.749 38.61C216.299 38.61 215.914 38.715 215.594 38.925C215.284 39.125 215.044 39.42 214.874 39.81C214.704 40.2 214.619 40.68 214.619 41.25C214.619 41.81 214.704 42.29 214.874 42.69C215.044 43.08 215.284 43.38 215.594 43.59C215.914 43.79 216.299 43.89 216.749 43.89C217.199 43.89 217.579 43.79 217.889 43.59C218.199 43.38 218.439 43.08 218.609 42.69C218.779 42.29 218.864 41.81 218.864 41.25C218.864 40.68 218.779 40.2 218.609 39.81C218.439 39.42 218.199 39.125 217.889 38.925C217.579 38.715 217.199 38.61 216.749 38.61ZM226.809 40.185C226.809 39.685 226.669 39.3 226.389 39.03C226.119 38.75 225.744 38.61 225.264 38.61C224.814 38.61 224.429 38.715 224.109 38.925C223.789 39.135 223.554 39.475 223.404 39.945L222.054 39.375C222.244 38.765 222.614 38.275 223.164 37.905C223.724 37.535 224.444 37.35 225.324 37.35C225.924 37.35 226.454 37.45 226.914 37.65C227.374 37.84 227.734 38.13 227.994 38.52C228.264 38.91 228.399 39.41 228.399 40.02V43.365C228.399 43.735 228.584 43.92 228.954 43.92C229.134 43.92 229.309 43.895 229.479 43.845L229.389 44.955C229.159 45.065 228.869 45.12 228.519 45.12C228.199 45.12 227.909 45.065 227.649 44.955C227.399 44.835 227.199 44.66 227.049 44.43C226.909 44.19 226.839 43.895 226.839 43.545V43.44L227.169 43.425C227.079 43.815 226.894 44.14 226.614 44.4C226.334 44.65 226.009 44.84 225.639 44.97C225.269 45.09 224.894 45.15 224.514 45.15C224.044 45.15 223.619 45.075 223.239 44.925C222.869 44.775 222.574 44.55 222.354 44.25C222.144 43.94 222.039 43.56 222.039 43.11C222.039 42.55 222.219 42.09 222.579 41.73C222.949 41.37 223.469 41.125 224.139 40.995L227.049 40.425L227.034 41.55L224.919 41.985C224.499 42.065 224.184 42.18 223.974 42.33C223.764 42.48 223.659 42.7 223.659 42.99C223.659 43.27 223.764 43.495 223.974 43.665C224.194 43.825 224.484 43.905 224.844 43.905C225.094 43.905 225.334 43.875 225.564 43.815C225.804 43.755 226.019 43.66 226.209 43.53C226.399 43.39 226.544 43.215 226.644 43.005C226.754 42.785 226.809 42.525 226.809 42.225V40.185ZM233.894 45.15C233.274 45.15 232.709 44.995 232.199 44.685C231.699 44.375 231.304 43.93 231.014 43.35C230.724 42.77 230.579 42.075 230.579 41.265C230.579 40.425 230.734 39.715 231.044 39.135C231.354 38.555 231.769 38.115 232.289 37.815C232.809 37.505 233.379 37.35 233.999 37.35C234.639 37.35 235.179 37.525 235.619 37.875C236.059 38.225 236.354 38.68 236.504 39.24L236.324 39.405V34.125H237.929V45H236.504L236.384 42.96L236.594 42.975C236.524 43.425 236.359 43.815 236.099 44.145C235.839 44.465 235.514 44.715 235.124 44.895C234.744 45.065 234.334 45.15 233.894 45.15ZM234.239 43.86C234.669 43.86 235.039 43.75 235.349 43.53C235.659 43.31 235.899 43 236.069 42.6C236.239 42.2 236.324 41.72 236.324 41.16C236.324 40.64 236.239 40.195 236.069 39.825C235.899 39.445 235.659 39.155 235.349 38.955C235.049 38.755 234.699 38.655 234.299 38.655C233.629 38.655 233.109 38.885 232.739 39.345C232.369 39.805 232.184 40.44 232.184 41.25C232.184 42.06 232.364 42.7 232.724 43.17C233.084 43.63 233.589 43.86 234.239 43.86ZM241.228 36.24C240.878 36.24 240.608 36.155 240.418 35.985C240.238 35.805 240.148 35.555 240.148 35.235C240.148 34.915 240.238 34.67 240.418 34.5C240.608 34.33 240.878 34.245 241.228 34.245C241.568 34.245 241.828 34.33 242.008 34.5C242.198 34.67 242.293 34.915 242.293 35.235C242.293 35.555 242.198 35.805 242.008 35.985C241.828 36.155 241.568 36.24 241.228 36.24ZM242.023 37.5V45H240.418V37.5H242.023ZM244.534 45V37.5H245.959L246.064 39.45L245.854 39.24C245.994 38.81 246.194 38.455 246.454 38.175C246.724 37.885 247.039 37.675 247.399 37.545C247.769 37.415 248.159 37.35 248.569 37.35C249.099 37.35 249.574 37.455 249.994 37.665C250.424 37.865 250.764 38.17 251.014 38.58C251.264 38.99 251.389 39.51 251.389 40.14V45H249.784V40.635C249.784 39.895 249.629 39.385 249.319 39.105C249.019 38.815 248.639 38.67 248.179 38.67C247.849 38.67 247.529 38.75 247.219 38.91C246.909 39.06 246.649 39.305 246.439 39.645C246.239 39.985 246.139 40.44 246.139 41.01V45H244.534ZM260.421 35.925L260.676 37.185C260.646 37.185 260.616 37.185 260.586 37.185C260.556 37.175 260.526 37.17 260.496 37.17C260.016 37.17 259.651 37.275 259.401 37.485C259.151 37.685 259.026 37.98 259.026 38.37L258.246 38.01C258.246 37.61 258.331 37.255 258.501 36.945C258.671 36.625 258.911 36.375 259.221 36.195C259.541 36.015 259.901 35.925 260.301 35.925C260.321 35.925 260.341 35.925 260.361 35.925C260.381 35.925 260.401 35.925 260.421 35.925ZM258.051 43.83C258.811 43.83 259.401 44 259.821 44.34C260.241 44.67 260.451 45.13 260.451 45.72C260.451 46.24 260.286 46.685 259.956 47.055C259.626 47.435 259.176 47.725 258.606 47.925C258.046 48.125 257.401 48.225 256.671 48.225C255.441 48.225 254.531 48.035 253.941 47.655C253.351 47.275 253.056 46.8 253.056 46.23C253.056 45.83 253.196 45.48 253.476 45.18C253.766 44.88 254.251 44.71 254.931 44.67L254.841 44.91C254.421 44.82 254.081 44.66 253.821 44.43C253.571 44.19 253.446 43.855 253.446 43.425C253.446 42.995 253.611 42.63 253.941 42.33C254.271 42.03 254.736 41.855 255.336 41.805L256.176 42.21H255.996C255.536 42.25 255.211 42.355 255.021 42.525C254.831 42.695 254.736 42.885 254.736 43.095C254.736 43.345 254.826 43.53 255.006 43.65C255.196 43.77 255.461 43.83 255.801 43.83H258.051ZM256.671 47.025C257.221 47.025 257.671 46.97 258.021 46.86C258.381 46.76 258.646 46.625 258.816 46.455C258.996 46.295 259.086 46.115 259.086 45.915C259.086 45.685 258.991 45.5 258.801 45.36C258.621 45.22 258.291 45.15 257.811 45.15H255.396C255.116 45.15 254.881 45.22 254.691 45.36C254.501 45.51 254.406 45.71 254.406 45.96C254.406 46.29 254.606 46.55 255.006 46.74C255.406 46.93 255.961 47.025 256.671 47.025ZM256.611 37.35C257.271 37.35 257.841 37.455 258.321 37.665C258.811 37.875 259.186 38.17 259.446 38.55C259.716 38.93 259.851 39.375 259.851 39.885C259.851 40.395 259.716 40.84 259.446 41.22C259.186 41.6 258.811 41.895 258.321 42.105C257.841 42.315 257.271 42.42 256.611 42.42C255.571 42.42 254.771 42.19 254.211 41.73C253.661 41.26 253.386 40.645 253.386 39.885C253.386 39.375 253.521 38.93 253.791 38.55C254.061 38.17 254.436 37.875 254.916 37.665C255.406 37.455 255.971 37.35 256.611 37.35ZM256.611 38.475C256.151 38.475 255.766 38.605 255.456 38.865C255.156 39.115 255.006 39.455 255.006 39.885C255.006 40.315 255.156 40.66 255.456 40.92C255.766 41.18 256.151 41.31 256.611 41.31C257.081 41.31 257.466 41.18 257.766 40.92C258.076 40.66 258.231 40.315 258.231 39.885C258.231 39.455 258.076 39.115 257.766 38.865C257.466 38.605 257.081 38.475 256.611 38.475ZM269.68 45.15C269.06 45.15 268.495 44.995 267.985 44.685C267.485 44.375 267.09 43.93 266.8 43.35C266.51 42.77 266.365 42.075 266.365 41.265C266.365 40.425 266.52 39.715 266.83 39.135C267.14 38.555 267.555 38.115 268.075 37.815C268.595 37.505 269.165 37.35 269.785 37.35C270.425 37.35 270.965 37.525 271.405 37.875C271.845 38.225 272.14 38.68 272.29 39.24L272.11 39.405V34.125H273.715V45H272.29L272.17 42.96L272.38 42.975C272.31 43.425 272.145 43.815 271.885 44.145C271.625 44.465 271.3 44.715 270.91 44.895C270.53 45.065 270.12 45.15 269.68 45.15ZM270.025 43.86C270.455 43.86 270.825 43.75 271.135 43.53C271.445 43.31 271.685 43 271.855 42.6C272.025 42.2 272.11 41.72 272.11 41.16C272.11 40.64 272.025 40.195 271.855 39.825C271.685 39.445 271.445 39.155 271.135 38.955C270.835 38.755 270.485 38.655 270.085 38.655C269.415 38.655 268.895 38.885 268.525 39.345C268.155 39.805 267.97 40.44 267.97 41.25C267.97 42.06 268.15 42.7 268.51 43.17C268.87 43.63 269.375 43.86 270.025 43.86ZM280.539 40.185C280.539 39.685 280.399 39.3 280.119 39.03C279.849 38.75 279.474 38.61 278.994 38.61C278.544 38.61 278.159 38.715 277.839 38.925C277.519 39.135 277.284 39.475 277.134 39.945L275.784 39.375C275.974 38.765 276.344 38.275 276.894 37.905C277.454 37.535 278.174 37.35 279.054 37.35C279.654 37.35 280.184 37.45 280.644 37.65C281.104 37.84 281.464 38.13 281.724 38.52C281.994 38.91 282.129 39.41 282.129 40.02V43.365C282.129 43.735 282.314 43.92 282.684 43.92C282.864 43.92 283.039 43.895 283.209 43.845L283.119 44.955C282.889 45.065 282.599 45.12 282.249 45.12C281.929 45.12 281.639 45.065 281.379 44.955C281.129 44.835 280.929 44.66 280.779 44.43C280.639 44.19 280.569 43.895 280.569 43.545V43.44L280.899 43.425C280.809 43.815 280.624 44.14 280.344 44.4C280.064 44.65 279.739 44.84 279.369 44.97C278.999 45.09 278.624 45.15 278.244 45.15C277.774 45.15 277.349 45.075 276.969 44.925C276.599 44.775 276.304 44.55 276.084 44.25C275.874 43.94 275.769 43.56 275.769 43.11C275.769 42.55 275.949 42.09 276.309 41.73C276.679 41.37 277.199 41.125 277.869 40.995L280.779 40.425L280.764 41.55L278.649 41.985C278.229 42.065 277.914 42.18 277.704 42.33C277.494 42.48 277.389 42.7 277.389 42.99C277.389 43.27 277.494 43.495 277.704 43.665C277.924 43.825 278.214 43.905 278.574 43.905C278.824 43.905 279.064 43.875 279.294 43.815C279.534 43.755 279.749 43.66 279.939 43.53C280.129 43.39 280.274 43.215 280.374 43.005C280.484 42.785 280.539 42.525 280.539 42.225V40.185ZM286.656 35.295V42.75C286.656 43.12 286.751 43.39 286.941 43.56C287.141 43.73 287.406 43.815 287.736 43.815C288.006 43.815 288.241 43.775 288.441 43.695C288.641 43.605 288.826 43.485 288.996 43.335L289.356 44.505C289.126 44.705 288.841 44.865 288.501 44.985C288.171 45.095 287.801 45.15 287.391 45.15C286.961 45.15 286.566 45.08 286.206 44.94C285.846 44.8 285.566 44.575 285.366 44.265C285.166 43.945 285.061 43.53 285.051 43.02V35.745L286.656 35.295ZM289.236 37.5V38.76H283.611V37.5H289.236ZM295.202 40.185C295.202 39.685 295.062 39.3 294.782 39.03C294.512 38.75 294.137 38.61 293.657 38.61C293.207 38.61 292.822 38.715 292.502 38.925C292.182 39.135 291.947 39.475 291.797 39.945L290.447 39.375C290.637 38.765 291.007 38.275 291.557 37.905C292.117 37.535 292.837 37.35 293.717 37.35C294.317 37.35 294.847 37.45 295.307 37.65C295.767 37.84 296.127 38.13 296.387 38.52C296.657 38.91 296.792 39.41 296.792 40.02V43.365C296.792 43.735 296.977 43.92 297.347 43.92C297.527 43.92 297.702 43.895 297.872 43.845L297.782 44.955C297.552 45.065 297.262 45.12 296.912 45.12C296.592 45.12 296.302 45.065 296.042 44.955C295.792 44.835 295.592 44.66 295.442 44.43C295.302 44.19 295.232 43.895 295.232 43.545V43.44L295.562 43.425C295.472 43.815 295.287 44.14 295.007 44.4C294.727 44.65 294.402 44.84 294.032 44.97C293.662 45.09 293.287 45.15 292.907 45.15C292.437 45.15 292.012 45.075 291.632 44.925C291.262 44.775 290.967 44.55 290.747 44.25C290.537 43.94 290.432 43.56 290.432 43.11C290.432 42.55 290.612 42.09 290.972 41.73C291.342 41.37 291.862 41.125 292.532 40.995L295.442 40.425L295.427 41.55L293.312 41.985C292.892 42.065 292.577 42.18 292.367 42.33C292.157 42.48 292.052 42.7 292.052 42.99C292.052 43.27 292.157 43.495 292.367 43.665C292.587 43.825 292.877 43.905 293.237 43.905C293.487 43.905 293.727 43.875 293.957 43.815C294.197 43.755 294.412 43.66 294.602 43.53C294.792 43.39 294.937 43.215 295.037 43.005C295.147 42.785 295.202 42.525 295.202 42.225V40.185ZM300.305 42.975C300.645 42.975 300.915 43.075 301.115 43.275C301.325 43.465 301.43 43.725 301.43 44.055C301.43 44.385 301.325 44.65 301.115 44.85C300.915 45.05 300.645 45.15 300.305 45.15C299.955 45.15 299.675 45.05 299.465 44.85C299.265 44.65 299.165 44.385 299.165 44.055C299.165 43.725 299.265 43.465 299.465 43.275C299.675 43.075 299.955 42.975 300.305 42.975ZM304.407 42.975C304.747 42.975 305.017 43.075 305.217 43.275C305.427 43.465 305.532 43.725 305.532 44.055C305.532 44.385 305.427 44.65 305.217 44.85C305.017 45.05 304.747 45.15 304.407 45.15C304.057 45.15 303.777 45.05 303.567 44.85C303.367 44.65 303.267 44.385 303.267 44.055C303.267 43.725 303.367 43.465 303.567 43.275C303.777 43.075 304.057 42.975 304.407 42.975ZM308.508 42.975C308.848 42.975 309.118 43.075 309.318 43.275C309.528 43.465 309.633 43.725 309.633 44.055C309.633 44.385 309.528 44.65 309.318 44.85C309.118 45.05 308.848 45.15 308.508 45.15C308.158 45.15 307.878 45.05 307.668 44.85C307.468 44.65 307.368 44.385 307.368 44.055C307.368 43.725 307.468 43.465 307.668 43.275C307.878 43.075 308.158 42.975 308.508 42.975Z",
    fill: "#001B53",
    fillOpacity: 0.6
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_122_129776",
    x: 0,
    y: 0,
    width: 514,
    height: 444,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258611 0 0 0 0 0.308519 0 0 0 0 0.408333 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_122_129776"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.309804 0 0 0 0 0.407843 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_122_129776",
    result: "effect2_dropShadow_122_129776"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_122_129776",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_122_129776",
    x: 32,
    y: 78,
    width: 150,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.113509 0 0 0 0 0.119368 0 0 0 0 0.142805 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_122_129776"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_122_129776",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalReports);
export default __webpack_public_path__ + "static/media/vertical-reports.e577ff8401d3d799b64830cdf4ba4894.svg";
export { ForwardRef as ReactComponent };